import './Points.svelte.css.proxy.js';
/* src/components/recruit/Points.svelte generated by Svelte v3.32.3 */
import {
	SvelteComponent,
	append,
	attr,
	children,
	claim_element,
	claim_space,
	claim_text,
	detach,
	element,
	init,
	insert,
	noop,
	safe_not_equal,
	space,
	text
} from "../../_snowpack/pkg/svelte/internal.js";

function create_fragment(ctx) {
	let ul;
	let li0;
	let img0;
	let img0_src_value;
	let t0;
	let span0;
	let t1;
	let t2;
	let li1;
	let img1;
	let img1_src_value;
	let t3;
	let span1;
	let t4;
	let t5;
	let li2;
	let img2;
	let img2_src_value;
	let t6;
	let span2;
	let t7;

	return {
		c() {
			ul = element("ul");
			li0 = element("li");
			img0 = element("img");
			t0 = space();
			span0 = element("span");
			t1 = text("【幅広い年齢の方募集中】ミドル・シニア世代の方も大歓迎。整備士の仕事にブランクがある方も OK。");
			t2 = space();
			li1 = element("li");
			img1 = element("img");
			t3 = space();
			span1 = element("span");
			t4 = text("【充実した待遇】昇給年1回、賞与年2回。資格手当・役職手当などの充実で長く安心して働けます。");
			t5 = space();
			li2 = element("li");
			img2 = element("img");
			t6 = space();
			span2 = element("span");
			t7 = text("【プライベートもしっかり】土・日・祝休み、夏季・年末年始休あり。残業も月平均15時間程度。");
			this.h();
		},
		l(nodes) {
			ul = claim_element(nodes, "UL", { class: true });
			var ul_nodes = children(ul);
			li0 = claim_element(ul_nodes, "LI", { class: true });
			var li0_nodes = children(li0);
			img0 = claim_element(li0_nodes, "IMG", { src: true, alt: true, class: true });
			t0 = claim_space(li0_nodes);
			span0 = claim_element(li0_nodes, "SPAN", {});
			var span0_nodes = children(span0);
			t1 = claim_text(span0_nodes, "【幅広い年齢の方募集中】ミドル・シニア世代の方も大歓迎。整備士の仕事にブランクがある方も OK。");
			span0_nodes.forEach(detach);
			li0_nodes.forEach(detach);
			t2 = claim_space(ul_nodes);
			li1 = claim_element(ul_nodes, "LI", { class: true });
			var li1_nodes = children(li1);
			img1 = claim_element(li1_nodes, "IMG", { src: true, alt: true, class: true });
			t3 = claim_space(li1_nodes);
			span1 = claim_element(li1_nodes, "SPAN", {});
			var span1_nodes = children(span1);
			t4 = claim_text(span1_nodes, "【充実した待遇】昇給年1回、賞与年2回。資格手当・役職手当などの充実で長く安心して働けます。");
			span1_nodes.forEach(detach);
			li1_nodes.forEach(detach);
			t5 = claim_space(ul_nodes);
			li2 = claim_element(ul_nodes, "LI", { class: true });
			var li2_nodes = children(li2);
			img2 = claim_element(li2_nodes, "IMG", { src: true, alt: true, class: true });
			t6 = claim_space(li2_nodes);
			span2 = claim_element(li2_nodes, "SPAN", {});
			var span2_nodes = children(span2);
			t7 = claim_text(span2_nodes, "【プライベートもしっかり】土・日・祝休み、夏季・年末年始休あり。残業も月平均15時間程度。");
			span2_nodes.forEach(detach);
			li2_nodes.forEach(detach);
			ul_nodes.forEach(detach);
			this.h();
		},
		h() {
			if (img0.src !== (img0_src_value = "/images/check.png")) attr(img0, "src", img0_src_value);
			attr(img0, "alt", "✔");
			attr(img0, "class", "svelte-u6u2v7");
			attr(li0, "class", "svelte-u6u2v7");
			if (img1.src !== (img1_src_value = "/images/check.png")) attr(img1, "src", img1_src_value);
			attr(img1, "alt", "✔");
			attr(img1, "class", "svelte-u6u2v7");
			attr(li1, "class", "svelte-u6u2v7");
			if (img2.src !== (img2_src_value = "/images/check.png")) attr(img2, "src", img2_src_value);
			attr(img2, "alt", "✔");
			attr(img2, "class", "svelte-u6u2v7");
			attr(li2, "class", "svelte-u6u2v7");
			attr(ul, "class", "svelte-u6u2v7");
		},
		m(target, anchor) {
			insert(target, ul, anchor);
			append(ul, li0);
			append(li0, img0);
			append(li0, t0);
			append(li0, span0);
			append(span0, t1);
			append(ul, t2);
			append(ul, li1);
			append(li1, img1);
			append(li1, t3);
			append(li1, span1);
			append(span1, t4);
			append(ul, t5);
			append(ul, li2);
			append(li2, img2);
			append(li2, t6);
			append(li2, span2);
			append(span2, t7);
		},
		p: noop,
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(ul);
		}
	};
}

class Points extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, null, create_fragment, safe_not_equal, {});
	}
}

export default Points;
//# sourceMappingURL=Points.svelte.js.map
